var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoColoredBc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 62,
    viewBox: "0 0 216 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.0369 41.7297L88.8142 38.3966C90.546 39.998 92.8334 41.0765 94.9575 41.0765C97.4741 41.0765 98.8134 39.998 98.8134 38.2991C98.8134 36.5016 97.3425 35.9459 95.1855 35.0318L91.95 33.6596C89.4992 32.6469 87.0485 30.686 87.0485 27.1568C87.0485 23.2023 90.512 20.1641 95.4146 20.1641C98.2248 20.1641 101.035 21.2755 102.996 23.268L100.545 26.3074C99.0096 25.0327 97.4083 24.3137 95.4146 24.3137C93.2905 24.3137 91.9511 25.2617 91.9511 26.8619C91.9511 28.5937 93.6499 29.2151 95.7094 30.0317L98.8792 31.3722C101.82 32.5811 103.748 34.4444 103.748 37.9407C103.748 41.8953 100.448 45.2601 94.86 45.2601C91.6245 45.2601 88.3901 43.9854 86.0369 41.7308V41.7297Z",
    fill: "url(#paint0_linear_410_2228)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.082 24.6392H105.284V20.5872H123.78V24.6392H116.918V44.802H112.082V24.6392Z",
    fill: "url(#paint1_linear_410_2228)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M127.703 20.5872H136.134C141.198 20.5872 145.219 22.3847 145.219 27.9394C145.219 31.5673 143.389 33.8219 140.611 34.9004L146.264 44.802H140.873L135.906 35.6523H132.54V44.802H127.703V20.5872ZM135.677 31.8281C138.781 31.8281 140.513 30.5206 140.513 27.9394C140.513 25.3582 138.782 24.443 135.677 24.443H132.54V31.8281H135.677Z",
    fill: "url(#paint2_linear_410_2228)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M149.99 20.5871H164.826V24.6391H154.827V30.2267H163.323V34.2788H154.827V40.7487H165.185V44.8008H149.99V20.5859V20.5871Z",
    fill: "url(#paint3_linear_410_2228)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M174.727 20.5872H180.414L188.191 44.802H183.126L181.428 38.5929H173.585L171.887 44.802H166.985L174.73 20.5872H174.727ZM174.63 34.8346H180.381L179.662 32.1877C178.91 29.6711 178.257 26.8938 177.571 24.2797H177.407C176.786 26.9267 176.067 29.6711 175.349 32.1877L174.63 34.8346Z",
    fill: "url(#paint4_linear_410_2228)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M191.034 20.5872H196.394L200.512 31.9268C201.035 33.4306 201.492 35.0308 201.983 36.5675H202.146C202.669 35.0319 203.094 33.4306 203.617 31.9268L207.636 20.5872H212.996V44.802H208.584V34.7042C208.584 32.4167 208.944 29.0508 209.206 26.7633H209.042L207.082 32.4496L203.356 42.6121H200.579L196.82 32.4496L194.893 26.7633H194.762C194.991 29.0508 195.384 32.4167 195.384 34.7042V44.802H191.037V20.5872H191.034Z",
    fill: "url(#paint5_linear_410_2228)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.735 54.936C40.735 50.8068 44.2711 48.4423 48.2971 48.4423C50.3634 48.4423 52.0248 49.1919 53.1112 50.0572L51.13 51.9556C50.3203 51.3897 49.4901 50.9905 48.3606 50.9905C46.3158 50.9905 44.6329 52.4229 44.6329 54.8362C44.6329 57.2495 46.0811 58.7318 48.3186 58.7318C49.5967 58.7318 50.5981 58.2328 51.3432 57.5999L53.346 59.4644C52.0032 60.6801 50.2363 61.2959 48.1689 61.2959C44.1429 61.2959 40.7339 59.131 40.7339 54.936H40.735Z",
    fill: "url(#paint6_linear_410_2228)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3516 54.8022C57.3516 50.7399 60.2911 48.4423 64.6153 48.4423C68.9396 48.4423 71.8791 50.7569 71.8791 54.8022C71.8791 58.8474 68.9396 61.2959 64.6153 61.2959C60.2911 61.2959 57.3516 58.8656 57.3516 54.8022ZM68.0029 54.8022C68.0029 52.4047 66.7032 50.9894 64.6153 50.9894C62.5275 50.9894 61.2494 52.4047 61.2494 54.8022C61.2494 57.1996 62.5275 58.7318 64.6153 58.7318C66.7032 58.7318 68.0029 57.1996 68.0029 54.8022Z",
    fill: "url(#paint7_linear_410_2228)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1438 48.6589H82.2548L84.7691 54.0209C85.0889 54.7365 85.3441 55.519 85.6423 56.2686H85.7489C86.0687 55.519 86.3239 54.7365 86.6222 54.0209L89.0502 48.6589H93.1828V61.0635H89.7103V56.8175C89.7103 55.5859 90.0085 53.7373 90.2217 52.5216H90.1151L88.7939 55.4849L86.6641 60.0133H84.5763L82.4249 55.4849L81.1468 52.5216H81.0618C81.2534 53.7373 81.5517 55.5847 81.5517 56.8175V61.0635H78.1438V48.6589Z",
    fill: "url(#paint8_linear_410_2228)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M100.15 48.6589H104.261L106.776 54.0209C107.095 54.7365 107.351 55.519 107.649 56.2686H107.756C108.075 55.519 108.331 54.7365 108.629 54.0209L111.057 48.6589H115.189V61.0635H111.717V56.8175C111.717 55.5859 112.015 53.7373 112.228 52.5216H112.122L110.801 55.4849L108.671 60.0133H106.583L104.432 55.4849L103.153 52.5216H103.068C103.26 53.7373 103.558 55.5847 103.558 56.8175V61.0635H100.15V48.6589Z",
    fill: "url(#paint9_linear_410_2228)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M122.157 48.6589H132.212V51.1403H125.97V53.4379H131.274V55.9352H125.97V58.5662H132.446V61.0635H122.156V48.6589H122.157Z",
    fill: "url(#paint10_linear_410_2228)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M138.901 48.6589H144.716C148.104 48.6589 150.915 49.5741 150.915 52.5715C150.915 54.386 149.829 55.5519 148.189 56.1518L151.725 61.0635H147.464L144.546 56.7007H142.715V61.0635H138.902V48.6589H138.901ZM144.418 54.3531C146.229 54.3531 147.209 53.7373 147.209 52.5715C147.209 51.4057 146.229 51.0235 144.418 51.0235H142.714V54.3531H144.418Z",
    fill: "url(#paint11_linear_410_2228)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M156.583 54.936C156.583 50.8068 160.119 48.4423 164.145 48.4423C166.212 48.4423 167.873 49.1919 168.96 50.0572L166.978 51.9556C166.169 51.3897 165.338 50.9905 164.209 50.9905C162.164 50.9905 160.481 52.4229 160.481 54.8362C160.481 57.2495 161.929 58.7318 164.167 58.7318C165.445 58.7318 166.447 58.2328 167.192 57.5999L169.194 59.4644C167.852 60.6801 166.085 61.2959 164.017 61.2959C159.991 61.2959 156.582 59.131 156.582 54.936H156.583Z",
    fill: "url(#paint12_linear_410_2228)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M174.84 48.6589H178.653V61.0635H174.84V48.6589Z",
    fill: "url(#paint13_linear_410_2228)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M188.538 48.6589H193.097L198.018 61.0635H194.012L193.096 58.2158H188.409L187.493 61.0635H183.615L188.536 48.6589H188.538ZM189.135 55.9182H192.373L192.031 54.8692C191.605 53.6375 191.2 52.1553 190.775 50.8897H190.69C190.306 52.1882 189.88 53.6364 189.475 54.8692L189.135 55.9182Z",
    fill: "url(#paint14_linear_410_2228)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M203.004 48.6589H206.816V58.565H212.994V61.0623H203.002V48.6577L203.004 48.6589Z",
    fill: "url(#paint15_linear_410_2228)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8335 20.3002L0 60.2867H11.6039L38.2411 20.3002H26.8335Z",
    fill: "url(#paint16_linear_410_2228)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2966 20.3002H58.6897L47.1924 38.1392L45.134 20.3002H45.0898H39.6111H39.4829L12.6506 60.2867H18.4526L40.3947 27.3462L42.3737 45.1206H47.9976H48.4354L64.2966 20.3002Z",
    fill: "url(#paint17_linear_410_2228)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7757 20.3002V34.534C75.7757 37.4599 73.4032 39.8324 70.4773 39.8324H69.8275C66.9016 39.8324 64.5291 37.4599 64.5291 34.534V22.0909L59.2397 30.3674V34.568C59.2397 40.3961 63.9643 45.1218 69.7935 45.1218H70.5102C76.3382 45.1218 81.064 40.3972 81.064 34.568V20.3002H75.7746H75.7757Z",
    fill: "url(#paint18_linear_410_2228)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M127.96 7.99999L125.13 0.89999H126.19L129.01 7.99999H127.96ZM124.92 7.99999V0.89999H126.08V7.99999H124.92ZM128.25 7.99999V0.89999H129.41V7.99999H128.25Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M133.634 6.20999V0.89999H134.794V6.20999H133.634ZM130.614 6.20999V0.89999H131.774V6.20999H130.614ZM134.794 6.19999C134.794 6.57999 134.704 6.91666 134.524 7.20999C134.344 7.50332 134.097 7.73332 133.784 7.89999C133.47 8.06666 133.107 8.14999 132.694 8.14999V7.20999C132.987 7.20999 133.217 7.12332 133.384 6.94999C133.55 6.76999 133.634 6.51999 133.634 6.19999H134.794ZM130.614 6.19999H131.774C131.774 6.51999 131.857 6.76999 132.024 6.94999C132.19 7.12332 132.42 7.20999 132.714 7.20999V8.14999C132.307 8.14999 131.944 8.06666 131.624 7.89999C131.31 7.73332 131.064 7.50332 130.884 7.20999C130.704 6.91666 130.614 6.57999 130.614 6.19999Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M140.788 6.35999C140.788 6.12666 140.718 5.92332 140.578 5.74999C140.438 5.56999 140.254 5.39999 140.028 5.23999C139.808 5.07999 139.571 4.91999 139.318 4.75999C139.064 4.59332 138.824 4.40999 138.598 4.20999C138.378 4.00332 138.194 3.76332 138.048 3.48999C137.908 3.21666 137.838 2.89666 137.838 2.52999H138.998C138.998 2.75666 139.068 2.95999 139.208 3.13999C139.354 3.31999 139.538 3.48999 139.758 3.64999C139.984 3.80999 140.224 3.97332 140.478 4.13999C140.731 4.29999 140.968 4.48332 141.188 4.68999C141.414 4.88999 141.598 5.12666 141.738 5.39999C141.878 5.66666 141.948 5.98666 141.948 6.35999H140.788ZM137.838 2.53999C137.838 2.17999 137.928 1.86666 138.108 1.59999C138.288 1.32666 138.534 1.11666 138.848 0.96999C139.168 0.816657 139.531 0.73999 139.938 0.73999V1.68999C139.644 1.68999 139.414 1.76666 139.248 1.91999C139.081 2.06666 138.998 2.27332 138.998 2.53999H137.838ZM141.948 6.34999C141.948 6.71666 141.858 7.03332 141.678 7.29999C141.498 7.56666 141.251 7.77666 140.938 7.92999C140.624 8.07666 140.261 8.14999 139.848 8.14999V7.20999C140.141 7.20999 140.371 7.13332 140.538 6.97999C140.704 6.82666 140.788 6.61666 140.788 6.34999H141.948ZM140.788 2.52999C140.754 2.24999 140.658 2.03999 140.498 1.89999C140.344 1.75999 140.158 1.68999 139.938 1.68999V0.73999C140.278 0.73999 140.581 0.806657 140.848 0.93999C141.114 1.07332 141.331 1.25999 141.498 1.49999C141.671 1.73332 141.781 2.00999 141.828 2.32999L140.788 2.52999ZM138.748 5.91999C138.781 6.31999 138.894 6.63666 139.088 6.86999C139.281 7.09666 139.534 7.20999 139.848 7.20999V8.14999C139.241 8.14999 138.748 7.96999 138.368 7.60999C137.994 7.24999 137.771 6.74999 137.698 6.10999L138.748 5.91999Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M142.46 1.83999V0.89999H146.86V1.83999H142.46ZM144.08 7.99999V0.89999H145.24V7.99999H144.08Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M150.445 7.99999L149.185 4.59999H150.335L151.595 7.99999H150.445ZM148.575 5.13999V4.18999H149.425V5.13999H148.575ZM148.575 1.83999V0.89999H149.425V1.83999H148.575ZM150.355 3.19999V2.83999H151.515V3.19999H150.355ZM151.515 2.84999H150.355C150.355 2.52999 150.271 2.28332 150.105 2.10999C149.938 1.92999 149.708 1.83999 149.415 1.83999V0.89999C149.828 0.89999 150.191 0.983323 150.505 1.14999C150.818 1.31666 151.065 1.54666 151.245 1.83999C151.425 2.13332 151.515 2.46999 151.515 2.84999ZM151.515 3.18999C151.515 3.56999 151.425 3.90666 151.245 4.19999C151.065 4.49332 150.818 4.72332 150.505 4.88999C150.191 5.05666 149.828 5.13999 149.415 5.13999V4.18999C149.708 4.18999 149.938 4.10332 150.105 3.92999C150.271 3.74999 150.355 3.50332 150.355 3.18999H151.515ZM147.665 7.99999V0.89999H148.825V7.99999H147.665Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M153.356 7.99999V7.04999H156.046V7.99999H153.356ZM153.456 4.93999V3.97999H155.446V4.93999H153.456ZM152.596 0.89999H153.756V7.99999H152.596V0.89999ZM153.456 0.89999H155.946V1.83999H153.456V0.89999Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M157.842 6.68999V5.73999H160.392V6.68999H157.842ZM159.532 0.89999L157.782 7.99999H156.652L158.402 0.89999H159.532ZM159.552 0.89999L161.292 7.99999H160.162L158.422 0.89999H159.552Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M164.348 7.99999L165.918 0.89999H166.848L165.278 7.99999H164.348ZM164.318 7.99999L162.748 0.89999H163.678L165.248 7.99999H164.318ZM162.098 7.99999V0.89999H163.258V7.99999H162.098ZM166.338 7.99999V0.89999H167.498V7.99999H166.338Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M173.433 7.99999L172.173 4.59999H173.323L174.583 7.99999H173.433ZM171.563 5.13999V4.18999H172.413V5.13999H171.563ZM171.563 1.83999V0.89999H172.413V1.83999H171.563ZM173.343 3.19999V2.83999H174.503V3.19999H173.343ZM174.503 2.84999H173.343C173.343 2.52999 173.26 2.28332 173.093 2.10999C172.926 1.92999 172.696 1.83999 172.403 1.83999V0.89999C172.816 0.89999 173.18 0.983323 173.493 1.14999C173.806 1.31666 174.053 1.54666 174.233 1.83999C174.413 2.13332 174.503 2.46999 174.503 2.84999ZM174.503 3.18999C174.503 3.56999 174.413 3.90666 174.233 4.19999C174.053 4.49332 173.806 4.72332 173.493 4.88999C173.18 5.05666 172.816 5.13999 172.403 5.13999V4.18999C172.696 4.18999 172.926 4.10332 173.093 3.92999C173.26 3.74999 173.343 3.50332 173.343 3.18999H174.503ZM170.653 7.99999V0.89999H171.813V7.99999H170.653Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M176.344 7.99999V7.04999H179.034V7.99999H176.344ZM176.444 4.93999V3.97999H178.434V4.93999H176.444ZM175.584 0.89999H176.744V7.99999H175.584V0.89999ZM176.444 0.89999H178.934V1.83999H176.444V0.89999Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M180.83 6.68999V5.73999H183.38V6.68999H180.83ZM182.52 0.89999L180.77 7.99999H179.64L181.39 0.89999H182.52ZM182.54 0.89999L184.28 7.99999H183.15L181.41 0.89999H182.54Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M185.946 7.99999V7.04999H188.436V7.99999H185.946ZM185.086 7.99999V0.89999H186.246V7.99999H185.086Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M188.837 1.83999V0.89999H193.237V1.83999H188.837ZM190.457 7.99999V0.89999H191.617V7.99999H190.457Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M195.304 5.51999L196.954 0.89999H198.004L196.354 5.51999H195.304ZM195.294 7.99999V5.51999H196.354V7.99999H195.294ZM195.294 5.51999L193.644 0.89999H194.854L196.354 5.51999H195.294Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M200.958 7.99999V0.89999H202.118V7.99999H200.958Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M206.505 7.99999L203.675 0.89999H204.735L207.555 7.99999H206.505ZM203.465 7.99999V0.89999H204.625V7.99999H203.465ZM206.795 7.99999V0.89999H207.955V7.99999H206.795Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M209.059 6.20999V2.67999H210.219V6.20999H209.059ZM209.059 2.68999C209.059 2.30999 209.149 1.97332 209.329 1.67999C209.509 1.38666 209.755 1.15666 210.069 0.98999C210.389 0.823323 210.752 0.73999 211.159 0.73999V1.67999C210.865 1.67999 210.635 1.76999 210.469 1.94999C210.302 2.12332 210.219 2.36999 210.219 2.68999H209.059ZM209.059 6.20999H210.219C210.219 6.52332 210.302 6.76999 210.469 6.94999C210.635 7.12332 210.865 7.20999 211.159 7.20999V8.15999C210.752 8.15999 210.389 8.07666 210.069 7.90999C209.755 7.74332 209.509 7.51332 209.329 7.21999C209.149 6.92666 209.059 6.58999 209.059 6.20999ZM212.249 2.96999C212.215 2.56999 212.102 2.25666 211.909 2.02999C211.715 1.79666 211.462 1.67999 211.149 1.67999V0.73999C211.755 0.73999 212.249 0.91999 212.629 1.27999C213.009 1.63332 213.232 2.13332 213.299 2.77999L212.249 2.96999ZM212.249 5.91999L213.299 6.11999C213.232 6.75999 213.009 7.25999 212.629 7.61999C212.249 7.97999 211.755 8.15999 211.149 8.15999V7.20999C211.462 7.20999 211.715 7.09666 211.909 6.86999C212.102 6.64332 212.215 6.32666 212.249 5.91999Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M214.788 8.07999C214.588 8.07999 214.421 8.01666 214.288 7.88999C214.161 7.75666 214.098 7.58999 214.098 7.38999C214.098 7.18999 214.161 7.02332 214.288 6.88999C214.421 6.74999 214.588 6.67999 214.788 6.67999C214.988 6.67999 215.154 6.74999 215.288 6.88999C215.428 7.02332 215.498 7.18999 215.498 7.38999C215.498 7.58999 215.428 7.75666 215.288 7.88999C215.154 8.01666 214.988 8.07999 214.788 8.07999Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_410_2228",
    x1: 94.8929,
    y1: 20.7538,
    x2: 94.8929,
    y2: 42.8524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40ADEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_410_2228",
    x1: 114.533,
    y1: 21.1562,
    x2: 114.533,
    y2: 42.4789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40ADEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_410_2228",
    x1: 136.984,
    y1: 21.1562,
    x2: 136.984,
    y2: 42.4789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40ADEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_410_2228",
    x1: 157.588,
    y1: 21.155,
    x2: 157.588,
    y2: 42.4777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40ADEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_410_2228",
    x1: 177.589,
    y1: 21.1562,
    x2: 177.589,
    y2: 42.4789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40ADEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_410_2228",
    x1: 202.016,
    y1: 21.1562,
    x2: 202.016,
    y2: 42.4789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CEE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40ADEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_410_2228",
    x1: 47.0405,
    y1: 23.0185,
    x2: 47.0405,
    y2: 58.5639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_410_2228",
    x1: 64.6165,
    y1: 23.0185,
    x2: 64.6165,
    y2: 58.5639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_410_2228",
    x1: 85.6639,
    y1: 23.0185,
    x2: 85.6639,
    y2: 58.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_410_2228",
    x1: 107.67,
    y1: 23.0185,
    x2: 107.67,
    y2: 58.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_410_2228",
    x1: 127.302,
    y1: 23.0185,
    x2: 127.302,
    y2: 58.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_410_2228",
    x1: 145.313,
    y1: 23.0185,
    x2: 145.313,
    y2: 58.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_410_2228",
    x1: 162.889,
    y1: 23.0185,
    x2: 162.889,
    y2: 58.5639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_410_2228",
    x1: 176.746,
    y1: 23.0185,
    x2: 176.746,
    y2: 58.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_410_2228",
    x1: 190.818,
    y1: 23.0185,
    x2: 190.818,
    y2: 58.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_410_2228",
    x1: 207.998,
    y1: 23.0185,
    x2: 207.998,
    y2: 58.5639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_410_2228",
    x1: 19.1206,
    y1: 24.1436,
    x2: 19.1206,
    y2: 58.6445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_410_2228",
    x1: 38.4736,
    y1: 24.1436,
    x2: 38.4736,
    y2: 58.6445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_410_2228",
    x1: 70.153,
    y1: 24.1436,
    x2: 70.153,
    y2: 58.6445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCCCCC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoColoredBc);
export default __webpack_public_path__ + "static/media/logoColoredBC.8707db3fbbaa336eaa3c46f8a9a5809a.svg";
export { ForwardRef as ReactComponent };